<template>
  <div class="setting-page">
    <div class="panel">
      <div class="title">备份恢复</div>
      <p class="tip">数据备份电子档案归档。启用自动备份到邮箱，数据永不丢失。</p>
      <div class="form-row">
        <label>启用自动备份到邮箱</label>
        <Switch v-model="emailAuto" @change="saveEmailAuto"></Switch>
        <span class="space">已使用空间 {{ usedSpace }}</span>
        <Button color="primary" @click="startBackup">开始备份</Button>
        <Button @click="uploadBackup">上传本地备份</Button>
      </div>
    </div>

    <div class="panel">
      <Table :datas="datas" stripe>
        <TableItem title="备份名称" prop="name"></TableItem>
        <TableItem title="备份日期" prop="backupDate"></TableItem>
        <TableItem title="文件大小" prop="fileSize"></TableItem>
        <TableItem title="类型" prop="backupType"></TableItem>
        <TableItem title="状态" prop="status"></TableItem>
        <TableItem title="操作" :width="200">
          <template slot-scope="{ data }">
            <Button text-color="primary" size="xs" @click="restore(data)">恢复</Button>
            <Button text-color="primary" size="xs" @click="download(data)">下载</Button>
            <Button text-color="red" size="xs" @click="remove(data)">删除</Button>
          </template>
        </TableItem>
      </Table>
      <Pagination v-model="pagination" @change="loadData" layout="pager" small align="center" v-if="datas.length" />
      <p v-if="!datas.length" class="empty">暂无备份记录</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackupIndex',
  data() {
    return {
      emailAuto: false,
      usedSpace: '0B',
      datas: [],
      pagination: { page: 1, size: 10, total: 0 }
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const p = { page: this.pagination.page, pageSize: this.pagination.size };
      this.$api.setting.backup.page(p).then((res) => {
        this.datas = res.data.records || [];
        this.pagination.total = res.data.total || 0;
        this.usedSpace = this.datas.length ? this.datas.length + ' 条记录' : '0B';
      });
    },
    startBackup() {
      this.$api.setting.backup.start({ emailAuto: this.emailAuto ? 1 : 0 }).then(() => {
        this.$Message.success('备份已开始并生成记录');
        this.loadData();
      });
    },
    uploadBackup() {
      this.$api.setting.backup.upload({ name: '本地上传备份', fileSize: '—' }).then(() => {
        this.$Message.success('本地备份已记录');
        this.loadData();
      });
    },
    saveEmailAuto() {
      this.$api.setting.backup.setEmailAuto({ emailAuto: this.emailAuto ? 1 : 0 }).then(() => {
        this.$Message.success('自动备份设置已保存');
      });
    },
    restore(row) {
      this.$Confirm('确认恢复该备份？').then(() => {
        this.$api.setting.backup.restore(row.id).then(() => {
          this.$Message.success('已标记为恢复');
          this.loadData();
        });
      });
    },
    download(row) {
      this.$api.setting.backup.download(row.id).then((res) => {
        this.downloadJson('backup_' + row.id + '.json', res.data);
      });
    },
    remove(row) {
      this.$Confirm('确认删除该备份记录？').then(() => {
        this.$api.setting.backup.delete(row.id).then(() => {
          this.$Message.success('已删除');
          this.loadData();
        });
      });
    },
    downloadJson(filename, content) {
      const blob = new Blob([content], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.setting-page { padding: 16px; }
.panel { background: #fff; border-radius: 4px; padding: 16px; margin-bottom: 16px; }
.title { font-size: 16px; font-weight: bold; margin-bottom: 8px; }
.tip { color: #888; margin-bottom: 12px; }
.form-row { display: flex; gap: 12px; align-items: center; flex-wrap: wrap; }
.space { color: #888; }
.empty { text-align: center; color: #aaa; padding: 20px; }
</style>
